<app-header-bar></app-header-bar>
<ion-content>

  <div class="container">
    <div class="mt-3">
      <div class="race-preview shadow p-0 mb-2">
        <div class="px-3 border-bottom">
          <div class="d-flex  pt-3 mb-3">
            <ion-back-button defaultHref="results"></ion-back-button>
            <div class="d-flex flex-column">
              <span class="t">1730 Cabourg (FR)</span>
              <span class="t-faded t-smaller">100m Stakes</span>
            </div>
            <div class="extra d-flex">
              <div class="d-flex flex-column align-items-end">
                <span class="t-strong">16:00</span>
                <span class="t-faded t-smaller">23 Jul</span>
              </div>

              <a href="#" data-toggle="modal" data-target="#raceInfoModal" class="btn btn-tertiary icon ml-2">
                <span class="icon icon-info"></span>
              </a>
            </div>
          </div>
        </div>
        <div class="race-content">
          <table class="racing-table table-borderless table-striped">
            <colgroup>
              <col width="10%">
              <col width="10%">
              <col width="50%">
              <col width="10%">
              <col width="20%">
            </colgroup>
            <thead>
              <tr>
                <th class="text-center">P</th>
                <th>N</th>
                <th class="text-left">Selection</th>
                <th>Win</th>
                <th>Place</th>
              </tr>
            </thead>
            <tbody>

              <tr class="won">
                <td class="text-center">1</td>
                <td>3</td>
                <td class="text-left">Bonusdargent</td>
                <td>10</td>
                <td>27.5</td>
              </tr>

              <tr class="">
                <td class="text-center">2</td>
                <td>1</td>
                <td class="text-left">Charizard</td>
                <td>8</td>
                <td>27.5</td>
              </tr>

              <tr class="">
                <td class="text-center">3</td>
                <td>8</td>
                <td class="text-left">Diancie</td>
                <td>0</td>
                <td>27.5</td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="race-preview shadow p-0 mb-2">
      <div class="race-header bg-fill-secondary text-white">
        <div class="race-info">
          <div class="race-name text-uppercase">Odds</div>
        </div>
      </div>
      <div class="race-content">
        <table class="racing-table table-borderless table-striped">
          <colgroup>
            <col width="50%">
            <col width="10%">
            <col width="10%">
            <col width="30%">
          </colgroup>
          <thead>
            <tr>
              <th class="text-left">Selection</th>
              <th>N</th>
              <th>S</th>
              <th class="text-right">Odds / Win</th>
            </tr>
          </thead>
          <tbody>
            <tr class="won">
              <td class="text-left">Bonusdargent</td>
              <td>1</td>
              <td>G</td>
              <td class="text-right t-strong">10/3</td>
            </tr>

            <tr class="">
              <td class="text-left">Charizard</td>
              <td>2</td>
              <td>G</td>
              <td class="text-right t-strong">10/3</td>
            </tr>

            <tr class="">
              <td class="text-left">Diancie</td>
              <td>3</td>
              <td>G</td>
              <td class="text-right t-strong">10/3</td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>

  </div>

</ion-content>